module.exports = __webpack_public_path__ + "img/COCOCRUSH_RING.313e327b.jpg";